SJ.MovingObjects =
class {

  constructor(){
    this.moveOffsetValue = 10;
    this.isMoving = false;
  }

  objectMoveManagement(keyCode){

    if(keyCode === 77)
      this.setObjectToMove();

    if(this.isMoving)
      this.moveObject(keyCode);

    if(keyCode === 80){
      this.isMoving = !this.isMoving;

      if(this.isMoving)console.log('Object moving enabled');
      else console.log('Object moving disabled');
    }

    if(keyCode === 76 && this.object)
      this.showCurrentPosition();
    
    if(keyCode === 75)
      this.moveOffsetValue = parseInt(prompt('PODAJ NOWĄ WARTOŚĆ PRZESUNIĘCIA'));


  }

  setObjectToMove(){
    this.objectWorkingName = prompt('PODAJ NAZWĘ GRAFIKI');
    this.object = this.getObjectByName(this.objectWorkingName) || null;

    if(this.object)this.isMoving = true;
    else alert('NIE MA OBIEKTU O PODANEJ NAZWIE');
  }

  getObjectByName(objectName){
    this.obj;

    if(SJ.paralaxBackground){
      SJ.paralaxBackground._layers.forEach(layer => {
        layer.images.forEach(object => {
          if(object.workingName === objectName) this.obj = object;
        });
      });
    }

    if(SJ.PadCreator.pad && SJ.PadCreator.length > 0){
      SJ.PadCreator.pad.forEach(layer => {
        layer.images.forEach(object => {
          if(object.workingName === objectName) this.obj = object;
        });
      });
    }

    if(SJ.PadCreator.middleground){
      SJ.PadCreator.middleground.forEach(layer => {
        layer.images.forEach(object => {
          if(object.workingName === objectName) this.obj = object;
        });
      });
    }

    if(SJ.PadCreator.padImgFront){
      SJ.PadCreator.padImgFront.forEach(layer => {
        layer.images.forEach(object => {
          if(object.workingName === objectName) this.obj = object;
        });
      });
    }

    SJ.ScreensManager.currentScreen._drawable.forEach(object => this.checkObjectChildren(object, objectName));

    return this.obj;
  }


  checkObjectChildren(object, objectName){
    if(object.workingName){
        if(object.workingName === objectName) {
          this.obj = object;
        }
    }

    if(object.children.length > 0){
      object.children.forEach(objectChild => {
        this.checkObjectChildren(objectChild, objectName);
      });
    }
  }

  showCurrentPosition(){
    console.log('---curent object position---');
    console.log(`x: ${this.object.x},`);
    console.log(`y: ${this.object.y}`);
    console.log('----------------------------');
  }

  moveObject(keyCode){

    if(this.object){
      switch(keyCode){
        case 87:
          this.object.y -= this.moveOffsetValue;
        break;
        case 83:
          this.object.y += this.moveOffsetValue;
        break;
        case 68:
          this.object.x += this.moveOffsetValue;
        break;
        case 65: 
          this.object.x -= this.moveOffsetValue;
        break;
      }
    } 
  }
}